import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EBookCover = ({ ebook }) => {
  return (
    <div className="bg-card rounded-lg shadow-md overflow-hidden">
      <div className="aspect-[3/4] relative bg-muted">
        <Image
          src={ebook?.coverImage}
          alt={ebook?.coverImageAlt}
          className="w-full h-full object-cover"
        />
        {ebook?.badge && (
          <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-3 py-1 rounded-md text-sm font-medium">
            {ebook?.badge}
          </div>
        )}
      </div>
      <div className="p-4 md:p-6 space-y-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="BookOpen" size={16} />
          <span className="data-text">{ebook?.pageCount} pages</span>
        </div>
        
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Download" size={16} />
          <span className="data-text">{ebook?.downloadCount} downloads</span>
        </div>
        
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Star" size={16} />
          <span className="data-text">{ebook?.rating} ({ebook?.reviewCount} reviews)</span>
        </div>
        
        <div className="pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Shield" size={16} color="var(--color-success)" />
            <span className="text-success">Secure Download</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EBookCover;